import { Badge, Body } from '@e2n/ui/v2';
import { Location } from '@/domain/mitarbeiter/features/rotationsplan/components/Location';
import { ArbeitsbereichStation } from '@/domain/mitarbeiter/features/rotationsplan/entities/Station';
import dayjs from '@/domain/mitarbeiter/shared/utils/dayjs';
import { faCalendarRange, faUser } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle } from '@fortawesome/pro-solid-svg-icons';
import { useTranslation } from 'react-i18next';

export function Arbeitsbereich({
  arbeitsbereichStation,
  isNext = false,
  isPlanGestartet = false,
}: {
  arbeitsbereichStation: ArbeitsbereichStation;
  isNext?: boolean;
  isPlanGestartet?: boolean;
}) {
  const { t } = useTranslation();
  const datum = dayjs(arbeitsbereichStation.von).format('DD.MM.');

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-2">
        <FontAwesomeIcon
          icon={faCircle}
          color={arbeitsbereichStation.arbeitsbereich.getBorderColor()}
          className="size-2.5 shrink-0"
        />
        <Body className="truncate" size="sm" weight="semibold">
          {arbeitsbereichStation.arbeitsbereich.name}
        </Body>
        {isNext && (
          <Badge className="bg-neutrals-v2-200 text-labels-primary">
            {isPlanGestartet
              ? t(
                  'domain.mitarbeiter.rotationsplan.rotationsplaene.naechsteStationAb',
                  { datum },
                )
              : t(
                  'domain.mitarbeiter.rotationsplan.rotationsplaene.geplantAb',
                  { datum },
                )}
          </Badge>
        )}
      </div>
      <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-labels-secondary">
        <div className="flex gap-1 items-center">
          <FontAwesomeIcon className="size-3.5" icon={faCalendarRange} />
          <Body className="text-labels-secondary" size="sm">
            {dayjs(arbeitsbereichStation.von).format('DD.MM.YYYY') +
              ' – ' +
              dayjs(arbeitsbereichStation.bis).format('DD.MM.YYYY')}
          </Body>
        </div>
        {arbeitsbereichStation.abteilungsleiter && (
          <div className="flex items-center gap-1 min-w-0 max-w-32">
            <FontAwesomeIcon className="size-3.5 shrink-0" icon={faUser} />
            <Body className="text-labels-secondary truncate" size="sm">
              {arbeitsbereichStation.abteilungsleiter.getName()}
            </Body>
          </div>
        )}
        <Location
          className="text-labels-secondary"
          standort={arbeitsbereichStation.arbeitsbereich.standort}
        />
      </div>
    </div>
  );
}
